import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ScrollReveal } from "@/components/shared/ScrollReveal";
import { useLang } from "@/i18n/LanguageContext";

export default function CaseTeaser() {
  const { t } = useLang();
  const ch = t.caseHistory;

  return (
    <section data-testid="case-teaser" className="relative bg-black text-white overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <ScrollReveal>
          <Link
            to="/case-history"
            data-testid="case-teaser-link"
            className="group block border border-white/10 bg-black p-6 md:p-10 transition-colors duration-500 hover:border-white/30"
          >
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
              <div>
                <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-5">{ch.eyebrow}</p>
                <h3 className="font-display text-3xl sm:text-4xl md:text-5xl leading-[0.95] tracking-tight whitespace-pre-line">
                  {ch.title.split("\n").map((line, i, arr) =>
                    i === arr.length - 1 ? (
                      <span key={i} className="font-serif-italic text-[var(--dp-accent)]">
                        {line}
                      </span>
                    ) : (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    )
                  )}
                </h3>
              </div>
              <span className="inline-flex items-center gap-3 font-mono-eyebrow text-white shrink-0 border border-white/20 px-6 py-4 group-hover:bg-white group-hover:text-black transition-colors duration-300">
                {ch.teaserCta}
                <ArrowUpRight
                  size={14}
                  className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </span>
            </div>
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
